export const BONS_ENTREE = 'stock.bons.bonsEntree';
export const BONS_SORTIE = 'stock.bons.bonsSortie';
export const BONS_ENTREE_MAJ = 'stock.bons.bonsEntreeMaj';
export const BONS_SORTIE_MAJ = 'stock.bons.bonsSortieMaj';
export const BON_ENTREE_MAJ = 'stock.bons.bonEntreeMaj';
export const BON_SORTIE_MAJ = 'stock.bons.bonSortieMaj';
export const BON_ENTREE = 'stock.bons.bonEntree';
export const BON_SORTIE = 'stock.bons.bonSortie';

export const EDITION_BON_ENTREE_ROUTE = 'm.stock.bon_stock-entree';
export const EDITION_BON_SORTIE_ROUTE = 'm.stock.bon_stock-sortie';

export const LISTE_BON_ENTREE_ROUTE = 'l.stock.bon_stock-entree';
export const LISTE_BON_SORTIE_ROUTE = 'l.stock.bon_stock-sortie';

export const DETAILS_BON_ENTREE_ROUTE = 'c.stock.bon_stock-entree';
export const DETAILS_BON_SORTIE_ROUTE = 'c.stock.bon_stock-sortie';
export const DETAILS_BON_ENTREE_ROUTE_BY_LIGNE_COMMANDE_ID = 'c.stock.bon_stock-entree-ligneCmdeId';

export const DATE_DE_BON_ENTREE = 'stock.detailStock.dateBonEntree';
export const DATE_DE_BON_SORTIE = 'stock.detailStock.dateBonSortie';

export const ORIGINE_TYPE_DIVERS = 'BonDivers';
export const ORIGINE_TYPE_COMMANDE = 'Commande';

export const ORIGINE_BON_DIVERS = 'stock.origineType.bonDivers';
export const ORIGINE_COMMANDE = 'stock.origineType.commande';

export const BON_STOCK_TYPE_ENTREE = 'Entree';
export const BON_STOCK_TYPE_SORTIE = 'Sortie';

export const EXPORT_EXCEL_BONSTOCK = 'BonStock';

export const EXPORT_EXCEL_MOUVEMENT_STOCK = 'MouvementStock';
